import { Injectable, Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {SectorCategoryApi } from '../../../../theme/services/sdk';
import {BaToastNotificationService} from '../../../../theme/services/baToastNotification';

@Component({
  selector: 'app-sector-categories',
  templateUrl: './sector-categories.component.html',
  styleUrls: ['./sector-categories.component.scss'],
  providers:[SectorCategoryApi,BaToastNotificationService]
})

@Injectable()
export class SectorCategoriesComponent implements OnInit {

  private sectorCategorySource = new BehaviorSubject<object>({})
  sector_category = this.sectorCategorySource.asObservable();

  private sectorCategoriesSource = new BehaviorSubject<object>([])
  sector_categories = this.sectorCategoriesSource.asObservable();

  private totalItemsSource = new BehaviorSubject<number>(0)
  total_items = this.totalItemsSource.asObservable();

  private pSource = new BehaviorSubject<number>(1) // first page
  p = this.pSource.asObservable();

  private itemsPerPageSource = new BehaviorSubject<number>(10)
  itemsPerPage = this.itemsPerPageSource.asObservable();// number of items per page

  private searchingSource = new BehaviorSubject<boolean>(false)
  searching = this.searchingSource.asObservable();

  private editedIdSource = new BehaviorSubject<number>(null)
  editedId = this.editedIdSource.asObservable();

  constructor(protected sectorCategoryService:SectorCategoryApi,private toast: BaToastNotificationService) { }

  ngOnInit() {
    this.getSectorCategories(this.pSource.getValue());
    this.getCount();
  }

  refresh(){
    this.pSource.next(1);
    this.getSectorCategories(this.pSource.getValue());
    this.editedIdSource.next(null);
    this.getCount();
  }

  getSectorCategories(page: number){
    let skip = ( page - 1) * this.itemsPerPageSource.getValue();
    this.sectorCategoryService.find({
      order: "id DESC",
      include: ['sector','sectorType'],
      limit: this.itemsPerPageSource.getValue(),
      skip: skip
    })
        .subscribe((res) => {
              this.sectorCategoriesSource.next(res);
            },
            ((error) => {
              this.toast.error({
                heading: 'Error',
                text: 'Something went wrong. Reload to try again.',
                stack: 3
              });
            }))
  }

  getCount(){
    this.sectorCategoryService.count().subscribe((res) => {
      if(res)
        this.totalItemsSource.next(res.count);
    })
  }

  search(term: string, page:number){
    let skip = ( page - 1) * this.itemsPerPageSource.getValue();
    this.sectorCategoryService.search(term, this.itemsPerPageSource.getValue(), skip)
        .subscribe( results => {
              this.totalItemsSource.next(results.data.total);
              this.sectorCategoriesSource.next(results.data.sector_categories);
              this.searchingSource.next(false);
            },
            err => {
              this.toast.error({
                heading: 'Error',
                text: 'Something went wrong. Reload to try again.',
                stack: 3
              });
            })
  }

  updateSectorCategorySource(data){
    this.sectorCategorySource.next(data);
    this.editedIdSource.next(data.id);
  }

  cancelSelected(){
    this.editedIdSource.next(null);
    this.sectorCategorySource.next({});
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/sector-categories/sector-categories.component.ts